const registerUI = {
  default: {
    fields: ["user_name", "email", "password", "confirm_password"],
  },
};

export default registerUI;
